import { css } from '@emotion/react';
import { type FC } from 'react';
import { LinkComponent } from '~/_shared/baseComponents/links';
import { CONFIG } from '~/_shared/constants/config';
import {
  FORGOTTEN_PASSWORD_ROUTE, REGISTER_ROUTE,
} from '~/_shared/constants/routes';
import { useTranslation } from '~/_shared/utils/hooks';
import { authorizationPagesLinkStyle } from '../../authenticationPages.styles';

const linksWrapperStyle = css({
  marginTop: 20,
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  columnGap: 16,
  rowGap: 0,
});

type LoginFormLinksProps = Readonly<{
  isLoading: boolean;
}>;

export const LoginFormLinksComponent: FC<LoginFormLinksProps> = (props) => {
  const [t] = useTranslation();

  return (
    <div css={linksWrapperStyle}>
      <LinkComponent
        disabled={props.isLoading}
        path={FORGOTTEN_PASSWORD_ROUTE}
      >
        <span css={authorizationPagesLinkStyle}>{t('Forgot Password?')}</span>
      </LinkComponent>

      {CONFIG.SHOW_SIGNUP && (
        <LinkComponent
          disabled={props.isLoading}
          path={REGISTER_ROUTE}
        >
          <span css={authorizationPagesLinkStyle}>{t('Create Account')}</span>
        </LinkComponent>
      )}
    </div>
  );
};
